const isDevelopment = process.env.NODE_ENV === 'development'
export default Object.freeze({
  i () {
    if (!isDevelopment) return
    for (let msg of arguments) {
      console.log(msg)
    }
  },
  w () {
    if (!isDevelopment) return
    for (let msg of arguments) {
      console.warn(msg)
    }
  },
  e () {
    if (!isDevelopment) return
    for (let msg of arguments) {
      console.error(msg)
    }
  }
})
